import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import constants, { DISPLAY_MODES } from '../constants/common';

const { IFRAME_TITLE } = constants;

const AiChatPanel = React.forwardRef(
  ({ url, siteId, isOpen, displayMode, isMainMenuOpen, iframeRef }, ref) => {
    const src = `${url}?site_id=${siteId}`;

    const className = classNames('ws-ai-chat-panel', `ws-ai-chat-panel--${displayMode}`, {
      'ws-ai-chat-panel--hidden': !isOpen,
      'ws-ai-chat-panel--under-nav-overlay': isMainMenuOpen,
    });

    return (
      <div className={className} ref={ref} aria-hidden={!isOpen}>
        <iframe
          className="ws-ai-chat-panel__frame"
          ref={iframeRef}
          src={src}
          title={IFRAME_TITLE}
        />
      </div>
    );
  }
);

AiChatPanel.displayName = 'AiChatPanel';

AiChatPanel.propTypes = {
  url: PropTypes.string.isRequired,
  siteId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  displayMode: PropTypes.oneOf(Object.values(DISPLAY_MODES)).isRequired,
  isMainMenuOpen: PropTypes.bool.isRequired,
  iframeRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
};

export default React.memo(AiChatPanel);
